import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AgentConfig } from '@/config/agent-config';

interface AgentState {
  selectedAgent: AgentConfig | null;

  // DB-backed catalogue (replaces the old hardcoded AGENT_REGISTRY array).
  // Loaded once at app boot via useLoadAgents() and refreshed on demand.
  availableAgents: AgentConfig[];
  agentsLoaded: boolean;
  agentsLoading: boolean;
  agentsError: string | null;
}

const initialState: AgentState = {
  selectedAgent: null,
  availableAgents: [],
  agentsLoaded: false,
  agentsLoading: false,
  agentsError: null,
};

export const agentSlice = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    setSelectedAgent(state, action: PayloadAction<AgentConfig>) {
      state.selectedAgent = action.payload;
    },
    clearSelectedAgent(state) {
      state.selectedAgent = null;
    },

    // Catalogue lifecycle
    setAgentsLoading(state, action: PayloadAction<boolean>) {
      state.agentsLoading = action.payload;
      if (action.payload) state.agentsError = null;
    },
    setAvailableAgents(state, action: PayloadAction<AgentConfig[]>) {
      state.availableAgents = action.payload;
      state.agentsLoaded = true;
      state.agentsLoading = false;
      state.agentsError = null;
    },
    setAgentsError(state, action: PayloadAction<string>) {
      state.agentsError = action.payload;
      state.agentsLoading = false;
    },
  },
});

export const {
  setSelectedAgent,
  clearSelectedAgent,
  setAgentsLoading,
  setAvailableAgents,
  setAgentsError,
} = agentSlice.actions;
export default agentSlice.reducer;
